module.exports = __webpack_public_path__ + "static/media/girl.154b6635.png";